import React from 'react';
import { DaySliderWrapper, SpecialistListWrapper } from './BookingSystemPage.style';
import { BookingScheduleTime, Skeleton } from '@mindly/ui-components';
import { IonSkeletonText, IonSlides } from '@ionic/react';

const BookingSkeleton = () => {
  return (
    <>
      <SpecialistListWrapper style={{ paddingBottom: '22px' }}>
        <div
          style={{
            display: 'flex',
            width: '100%',
            gap: '16px',
          }}
        >
          <Skeleton heightPx={62} />
          <Skeleton heightPx={62} widthPx={77} style={{ borderRadius: '50%' }} />
        </div>
      </SpecialistListWrapper>
      <DaySliderWrapper
        style={{
          borderBottom: '1px solid #EEEEEE',
          paddingBottom: '8px',
        }}
      >
        <IonSlides>
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} heightPx={40} widthPx={84} style={{ marginRight: '20px', flexShrink: 0 }} />
          ))}
        </IonSlides>
      </DaySliderWrapper>
      <Skeleton widthPx={213} heightPx={20} style={{ marginBottom: '16px' }} />
      <BookingScheduleTime items={[]} isLoading={true} />
      <IonSkeletonText
        animated
        style={{
          margin: '35px 0 0 0',
          padding: 0,
          width: '100%',
          height: '20px',
          borderRadius: '6px',
        }}
      />
    </>
  );
};

export default BookingSkeleton;
